import { RCoefficientG_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'
const DataCoeffG = require('../json/CoeffG.json')

export function fetchCoefficientG(uuid: string): RCoefficientG_Type {
  return fetchGeneric(DataCoeffG, uuid)
}

export function fetchCoefficientGSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(DataCoeffG)
}
